import React from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { formatNumberWithCommas } from "../../utils";
import ServiceColumn from "./ServiceColumn";
import { Link } from "react-router-dom";
import { utils, writeFile } from "xlsx-js-style";
import {
  ServiceBackground,
  ServiceConact,
} from "./ServiceColumn";
import {
  getOrderType,
  getReason,
} from "../../models/ReportOperatorSalary";
import { getCurrentFortnightNameByCranesOrders } from "../../models/ReportByCranesOrders";

const TableClerksByOrder = ({ orders, start, end }) => {
  const hasData = orders && orders.length > 0;
  const baseUrl = window.location.origin;

  const exportClerksByOrderToExcel = (clerkOrders) => {
    if (!clerkOrders || clerkOrders.length === 0) {
      return;
    }

    const workbook = utils.book_new();

    const firstOrder = clerkOrders[0];
    const clerk = firstOrder.clerk || firstOrder.Clerk;
    const clerkName = clerk ? `${clerk.name || ""} ${clerk.first_surname || ""} ${clerk.second_surname || ""}`.trim() : "Sin nombre";
    const sheetName = `${clerkName}`.substring(0, 30).toUpperCase().replace(/\//g, '_');

    const sheetData = [
      [
        "Folio",
        "Descripción del servicio",
        "Tipo de Servicio",
        "Fecha",
        "Total (Sin IVA)",
        "KM aproximados",
        "Operador",
        "Razón",
      ],
    ];

    let totalSubtotal = 0;
    let totalDistanceSum = 0;

    clerkOrders.forEach((order) => {
      const orderType =
        order.tipoServicio != null
          ? order.tipoServicio
          : getOrderType(order);

      const bg = ServiceBackground({ row: order });

      const reason = order.razon?.trim() ? order.razon : getReason(order);

      const subtotal = order.orden_en_cero
        ? 0
        : Number(order.subtotal) || 0;

      totalSubtotal += subtotal;
      totalDistanceSum += Number(order.totalDistance) || 0;

      const operator =
        order.operadores &&
        order.operadores.length > 0 &&
        order.operadores[0].User
          ? `${order.operadores[0].User.name || ""} ${
              order.operadores[0].User.first_surname || ""
            } ${
              order.operadores[0].User.second_surname || ""
            }`.trim()
          : order.operador
          ? `${order.operador.name || ""} ${
              order.operador.first_surname || ""
            } ${order.operador.second_surname || ""}`.trim()
          : "SIN OPERADOR ASIGNADO";

      sheetData.push([
        {
          t: "s",
          v: order.folio?.toString().padStart(5, "0") || "SIN FOLIO",
          l: {
            Target:
              order.tipo === "Varo Express"
                ? `${baseUrl}/orders-vial/editOrder/${order.id}`
                : `${baseUrl}/orders/edit/${order.id}`,
          },
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: orderType,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: ServiceConact({ row: order }),
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: order.fecha_hora_reporte
            ? format(new Date(order.fecha_hora_reporte), "dd/MMM/yyyy", {
                locale: es,
              })
            : "SIN FECHA",
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: subtotal,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: Number(order.totalDistance) || 0,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: operator,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: reason,
          s: { fill: { fgColor: { rgb: bg } } },
        },
      ]);
    });

    sheetData.push([{ t: "s", v: "" }]); // línea vacía

    sheetData.push([
      { t: "s", v: "Total" },
      { t: "s", v: "" },
      { t: "s", v: "" },
      { t: "s", v: "" },
      { t: "n", v: totalSubtotal },
      { t: "n", v: totalDistanceSum },
      { t: "s", v: "" },
      { t: "s", v: "" },
    ]);

    const worksheet = utils.aoa_to_sheet(sheetData);
    worksheet["!cols"] = [
      { wch: 20 },
      { wch: 35 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
      { wch: 20 },
      { wch: 35 },
      { wch: 35 },
    ];

    utils.book_append_sheet(workbook, worksheet, sheetName);

    const fileName = getCurrentFortnightNameByCranesOrders(start, end);
    writeFile(workbook, `${sheetName} ( ${fileName} ).xlsx`);
  };

  const CLERK_CONTAINER_HEIGHT = "210px";

  const groupedByClerk = orders.reduce((acc, order) => {
    const clerkId = order.clerk?.id || order.Clerk?.id;

    if (!clerkId) {
      const noClerkKey = "sin-oficinista";
      if (!acc[noClerkKey]) {
        acc[noClerkKey] = {
          clerk: null,
          orders: [],
        };
      }
      acc[noClerkKey].orders.push(order);
      return acc;
    }

    if (!acc[clerkId]) {
      acc[clerkId] = {
        clerk: order.clerk || order.Clerk,
        orders: [],
      };
    }

    if (order.id) {
      acc[clerkId].orders.push(order);
    }
    return acc;
  }, {});

  const getClerkName = (clerk) => {
    if (!clerk) return "Sin oficinista";
    const name = clerk.name || "";
    const firstName = clerk.first_surname || "";
    const secondName = clerk.second_surname || "";
    return `${name} ${firstName} ${secondName}`.trim();
  };

  return (
    <div className="table-responsive mb-3">
      <table
        className="table table-hover table-panel text-nowrap align-middle mb-0"
        style={{ tableLayout: "fixed", width: "100%" }}
      >
        <colgroup>
          <col style={{ width: "180px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "130px" }} />
          <col style={{ width: "130px" }} />
          <col style={{ width: "200px" }} />
          <col style={{ width: "120px" }} />
        </colgroup>
        <thead className="sticky-thead table-light text-center">
          <tr>
            <th
              className="align-middle"
              style={{
                width: "180px",
                maxWidth: "200px",
                minWidth: "180px",
                whiteSpace: "normal",
                wordWrap: "break-word",
                overflowWrap: "break-word",
              }}
            >
              Oficinista
            </th>
            <th className="align-middle" style={{ width: "100px" }}>
              Orden
            </th>
            <th className="align-middle" style={{ width: "150px" }}>
              Operador
            </th>
            <th className="align-middle" style={{ width: "130px" }}>
              KM aproximados
            </th>
            <th className="align-middle" style={{ width: "130px" }}>
              Total (Sin IVA)
            </th>
            <th className="align-middle" style={{ width: "200px" }}>
              Descripción del servicio
            </th>
            <th className="align-middle" style={{ width: "120px" }}>
              Fecha
            </th>
          </tr>
        </thead>

        <tbody>
          {!hasData ? (
            <tr>
              <td colSpan="7" className="text-center py-5">
                <div className="text-muted fs-5">
                  No hay registros disponibles por ahora
                  <br />
                  <small>
                    Intenta ajustar los filtros o verificar la información
                  </small>
                </div>
              </td>
            </tr>
          ) : (
            Object.entries(groupedByClerk).map(
              ([clerkId, { clerk, orders: clerkOrders }], index) => {
                const totalSubtotal = clerkOrders.reduce(
                  (sum, o) => sum + (o.orden_en_cero ? 0 : (Number(o.subtotal) || 0)),
                  0
                );

                const totalKilometros = clerkOrders.reduce(
                  (sum, o) => sum + (parseFloat(o.totalDistance) || 0),
                  0
                );

                const bgClass =
                  index % 2 === 0 ? "table-primary" : "table-secondary";

                const visibleOrders = clerkOrders.slice(0, 3);
                const scrollableOrders = clerkOrders.slice(3);
                const hasScrollableOrders = scrollableOrders.length > 0;

                const clerkName = getClerkName(clerk);

                return (
                  <React.Fragment key={clerkId}>
                    <tr>
                      <td
                        rowSpan={2}
                        className={`fw-bold align-middle text-center ${bgClass}`}
                        style={{
                          verticalAlign: "top",
                          padding: "1.5rem 0.75rem",
                          fontSize: "1rem",
                          letterSpacing: "0.5px",
                          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
                          borderRight: "2px solid rgba(0,0,0,0.1)",
                          fontWeight: "600",
                          width: "180px",
                          maxWidth: "200px",
                          minWidth: "180px",
                          color: "#000",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          wordBreak: "break-word",
                          height: CLERK_CONTAINER_HEIGHT,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            lineHeight: "1.4",
                          }}
                        >
                          <span style={{ whiteSpace: "normal" }}>
                            {clerkName}
                          </span>
                        </div>
                      </td>

                      <td
                        colSpan="6"
                        style={{
                          padding: 0,
                          height: CLERK_CONTAINER_HEIGHT,
                          verticalAlign: "top",
                        }}
                      >
                        <div
                          style={{
                            height: CLERK_CONTAINER_HEIGHT,
                            maxHeight: CLERK_CONTAINER_HEIGHT,
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          <table
                            className="table table-hover table-panel text-nowrap align-middle mb-0"
                            style={{
                              marginBottom: 0,
                              tableLayout: "fixed",
                              width: "100%",
                            }}
                          >
                            <colgroup>
                              <col style={{ width: "100px" }} />
                              <col style={{ width: "150px" }} />
                              <col style={{ width: "130px" }} />
                              <col style={{ width: "130px" }} />
                              <col style={{ width: "200px" }} />
                              <col style={{ width: "120px" }} />
                            </colgroup>
                            <tbody>
                              {clerkOrders.length === 0 ? (
                                <tr>
                                  <td colSpan="6" className="text-center text-muted py-3">
                                    No hay órdenes para este oficinista
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  {visibleOrders.map((order) => {
                                    const operator =
                                      order.operadores &&
                                        order.operadores.length > 0 &&
                                        order.operadores[0].User
                                        ? `${order.operadores[0].User.name || ""} ${order.operadores[0].User.first_surname ||
                                          ""
                                          } ${order.operadores[0].User.second_surname ||
                                          ""
                                          }`.trim()
                                        : "SIN OPERADOR ASIGNADO";

                                    return (
                                      <tr className="text-center" key={order.id}>
                                        <td>
                                          <Link to={order.tipo === "Varo Express"
                                            ? `/orders-vial/editOrder/${order.id}`
                                            : `/orders/edit/${order.id}`
                                          }
                                          >
                                            {order.folio?.toString().padStart(5, "0") || "SIN FOLIO"}
                                          </Link>
                                        </td>
                                        <td
                                          style={{
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            overflowWrap: "break-word",
                                            textAlign: "center",
                                          }}
                                        >
                                          {operator}
                                        </td>
                                        <td>
                                          {!isNaN(Number(order?.totalDistance))
                                            ? `${Number(order?.totalDistance).toFixed(2)} km`
                                            : "0.00 km"}
                                        </td>
                                        <td>
                                          $
                                          {formatNumberWithCommas(
                                            order.orden_en_cero ? 0 : (order.subtotal || 0)
                                          )}
                                        </td>
                                        <td
                                          style={{
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            overflowWrap: "break-word",
                                            textAlign: "center",
                                          }}
                                        >
                                          <ServiceColumn row={order} />
                                        </td>
                                        <td>
                                          {order.fecha_hora_reporte
                                            ? format(
                                              new Date(order.fecha_hora_reporte),
                                              "dd/MMM/yyyy",
                                              { locale: es }
                                            )
                                            : "SIN FECHA DE ORDEN"}
                                        </td>
                                      </tr>
                                    );
                                  })}

                                  {scrollableOrders.map((order) => {
                                    const operator =
                                      order.operadores &&
                                        order.operadores.length > 0 &&
                                        order.operadores[0].User
                                        ? `${order.operadores[0].User.name || ""} ${order.operadores[0].User.first_surname ||
                                          ""
                                          } ${order.operadores[0].User.second_surname ||
                                          ""
                                          }`.trim()
                                        : "SIN OPERADOR ASIGNADO";

                                    return (
                                      <tr className="text-center" key={order.id}>
                                        <td>
                                          <Link to={order.tipo === "Varo Express"
                                            ? `/orders-vial/editOrder/${order.id}`
                                            : `/orders/edit/${order.id}`
                                          }
                                          >
                                            {order.folio?.toString().padStart(5, "0") || "SIN FOLIO"}
                                          </Link>
                                        </td>
                                        <td
                                          style={{
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            overflowWrap: "break-word",
                                            textAlign: "center",
                                          }}
                                        >
                                          {operator}
                                        </td>
                                        <td>
                                          {!isNaN(Number(order?.totalDistance))
                                            ? `${Number(order?.totalDistance).toFixed(2)} km`
                                            : "0.00 km"}
                                        </td>
                                        <td>
                                          $
                                          {formatNumberWithCommas(
                                            order.orden_en_cero ? 0 : (order.subtotal || 0)
                                          )}
                                        </td>
                                        <td
                                          style={{
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            overflowWrap: "break-word",
                                            textAlign: "center",
                                          }}
                                        >
                                          <ServiceColumn row={order} />
                                        </td>
                                        <td>
                                          {order.fecha_hora_reporte
                                            ? format(
                                              new Date(order.fecha_hora_reporte),
                                              "dd/MMM/yyyy",
                                              { locale: es }
                                            )
                                            : "SIN FECHA DE ORDEN"}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>

                    <tr className={`${bgClass} text-center fw-bold`}>
                      <td>
                        {(visibleOrders.length + scrollableOrders.length) === 0
                          ? "0 órdenes"
                          : (visibleOrders.length + scrollableOrders.length) === 1
                            ? "1 orden"
                            : `${visibleOrders.length + scrollableOrders.length} órdenes`}
                      </td>
                      <td></td>
                      <td>{totalKilometros.toFixed(2)} km</td>
                      <td>${formatNumberWithCommas(totalSubtotal)}</td>
                      <td></td>
                      <td>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() =>
                            exportClerksByOrderToExcel(clerkOrders)
                          }
                          title="Descargar reporte individual"
                        >
                          <i className="fa-solid fa-file-excel" />
                          &nbsp;Descargar
                        </button>
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan="7"
                        style={{ height: "10px", backgroundColor: "#f8f9fa" }}
                      ></td>
                    </tr>
                  </React.Fragment>
                );
              }
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableClerksByOrder;